import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
  Container,
  Row } from 'reactstrap';

class PersonifySignAgreement extends Component {
  render() {
    return (
      <div className="page-personify">
        <Container fluid>
          <Row>
            <Col className="text-center mb-2 mt-4 ml-auto mr-auto">
              <img src="/images/personify-approve.svg" alt="Approved" className="mb-3" />
              <h2>You're Approved!</h2>
              <p className="mb-4">Please review and sign your loan agreement below</p>
            </Col>
          </Row>
          <Row>
            <Col className="e-sign-placeholder">&nbsp;</Col>
          </Row>
          <Row>
            <Col className="text-center mt-4">
              <Button tag={Link} to="/dashboard" color="personify" size="lg" className="mb-2 mt-1">Complete &amp; Return to Dashboard</Button>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default PersonifySignAgreement;
